import React from 'react';
import { Box, Typography, Divider, Chip, useTheme } from '@mui/material';

const SectionHeader = ({ 
  id, 
  title, 
  subtitle, 
  icon: Icon, 
  isNew = false,
  level = 1,
  divider = true,
  sx = {} 
}) => {
  const theme = useTheme();
  
  // Map level to appropriate variant
  const variantMap = {
    1: 'h4',
    2: 'h5',
    3: 'h6',
    4: 'subtitle1',
    5: 'subtitle2'
  };
  
  const variant = variantMap[level] || 'h4';
  
  return (
    <Box id={id} sx={{ mt: level === 1 ? 5 : 3, mb: 3, ...sx }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: subtitle ? 1 : 0 }}>
        {Icon && (
          <Icon 
            sx={{ 
              mr: 1.5, 
              color: theme.palette.mode === 'dark' ? theme.palette.primary.light : theme.palette.primary.main,
              fontSize: level === 1 ? '2rem' : '1.5rem',
              filter: theme.palette.mode === 'dark' ? 'drop-shadow(0 0 3px rgba(33, 150, 243, 0.4))' : 'none'
            }} 
          />
        )}
        <Typography 
          variant={variant} 
          component={`h${level}`}
          sx={{ 
            fontWeight: 'bold',
            color: level === 1 
              ? (theme.palette.mode === 'dark' ? theme.palette.primary.light : theme.palette.primary.main)
              : theme.palette.text.primary
          }}
        >
          {title}
          {isNew && (
            <Chip 
              label="New" 
              size="small" 
              color="primary" 
              sx={{ 
                ml: 1.5, 
                height: 20, 
                fontSize: '0.7rem',
                boxShadow: theme.palette.mode === 'dark' ? '0 0 8px rgba(33, 150, 243, 0.5)' : 'none'
              }} 
            />
          )}
        </Typography>
      </Box>
      {subtitle && (
        <Typography 
          variant="body1" 
          color="text.secondary"
          sx={{ ml: Icon ? 4.5 : 0, mb: 1 }}
        >
          {subtitle}
        </Typography>
      )}
      {divider && (
        <Divider 
          sx={{ 
            mt: 1, 
            mb: 3,
            borderColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.1)' : undefined
          }} 
        />
      )}
    </Box>
  );
};

export default SectionHeader;